import React, { FC } from 'react';
import './NoResultCard.css';
import { FaTimesCircle } from '@/Shared/Lib/UI/Icons';

interface NoResultCardProps { }

const NoResultCard: FC<NoResultCardProps> = () => (
	<div className="DataRowCard" data-testid="DataRowCard">
		<div className="DataRowCard__header">
			<span className='DataRowCard__header-main-icon'><FaTimesCircle /></span>
		</div>
		<div className="DataRowCard__body">
			Aucun résultat trouvé
		</div>
	</div>
);

export default NoResultCard;